import repository from './repository';
import axios from "axios";

let repo = repository('/users');

const API = process.env.VUE_APP_API_URL;
const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,4096}$/;

repo.getUserInfo = () => {
    return axios.get(API + '/account/info');
};

repo.updateAccountInfo = (data) => {
    return axios.post(API + '/account/edit/info', data);
};

repo.editPassword = (password) => {
    return axios.post(API + '/account/edit/password', password);
};

repo.getProjectsInfo = () => {
    return axios.get(API + '/account/projects');
};

repo.accountInfo = () => {
    return {
        firstname: '',
        lastname: '',
        email: '',
    };
};

// Simple function to get an empty user
repo.blankUser = () => {
    return {
        firstname: '',
        lastname: '',
        email: '',
        role: '',
        amount_of_projects: 0,
    };
};

// Validation logic
function validateName(name) {
    return (name.length >= process.env.VUE_APP_VALIDATION_USER_MIN_NAME_LENGTH && name.length <= 250) || name.length === 0;
}

repo.validate = {
    firstName(name) {
        return validateName(name);
    },
    lastName(name) {
        return validateName(name);
    },
    email(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase()) || email.length === 0;
    },
    password(password) {
        return passwordRegex.test(password);
    },
    passwordRepeat(password, passwordRepeat) {
        return ((passwordRegex.test(passwordRepeat)) && (password === passwordRepeat));
    },
    passwordHasNumber(password) {
        let re = /[0-9]/;
        return re.test(String(password));
    },
    passwordHasUppercase(password) {
        let re = /[A-Z]/;
        return re.test(String(password));
    },
    passwordHasLowercase(password) {
        let re = /[a-z]/;
        return re.test(String(password));
    },
    passwordHasSpecialCharacter(password) {
        let re = /[!@#$%^&*(),.?":{}|<>]/;
        return re.test(String(password));
    },
    passwordHasLength(password) {
        let re = /\s/;
        return password.length >= 8 && password.length <= 4096 && !re.test(String(password));
    }
};

export default repo;
